import * as React from 'react';
import { Typography } from 'antd';
const { Text, Paragraph } = Typography;

export interface WidgetGraphicTextViewProps {
  text: string | null | undefined;
}

/**
 * Trasformazione del testo multilinea in React
 */
export function WidgetGraphicMultilineText(props: WidgetGraphicTextViewProps) {
  if (!props.text) return null;

  const tokens = props.text.split('\n');
  return (
    <>
      {tokens.map(token => (
        <>
          {token}
          <br />
        </>
      ))}
    </>
  );
}
